// extracted by mini-css-extract-plugin
export default {"shared":"\"../../../shared/shared.module.css\"","sm":"576px","container":"Header_container__caUwq","closeButton":"Header_closeButton__m6mY2","header":"Header_header__F9FZo"};